<template>
  <div class="cursorButton" :class="{ cursorButtonOn: isButtonOn }">
    <a href="javascript:void(0);" @click="questionnaire">
      <img src="/img/pageQuestionnaire2.png" srcset="/img/pageQuestionnaire2@2x.png 2x" alt="アンケート">
    </a>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      isButtonOn: false
    }
  },
  mounted () {
    // スクロールイベント設定
    window.addEventListener('scroll', this.scrollHandler)
  },
  methods: {
    questionnaire () {
      this.$ga.event('Questionnaire', 'link', location.href, 0)
      window.open('https://forms.gle/gCJEvubZ3yTqnU828')
    },
    scrollHandler () {
      if (window.scrollY > 100) {
        this.isButtonOn = true
      } else {
        this.isButtonOn = false
      }
    }
  }
}
</script>

<style scoped>
.cursorButton {
  position: fixed;
  width: 59px;
  height: 59px;
  left: 20px;
  bottom: 20px;
  opacity: 0;
  transition: all 1s;
  visibility: hidden;
  z-index: 3000;
}

.cursorButtonOn {
  opacity: 1;
  transition: all 1s;
  visibility: visible;
}

.cursorButton img {
  width: 59px;
  height: 59px;
}

@media screen and ( max-width:640px) {
  .cursorButton {
    width: 38px;
    height: 38px;
  }

  .cursorButton img {
    width: 38px;
    height: 38px;
  }
}
</style>
